import { createFileRoute } from "@tanstack/react-router";
import { QuestionBankScreen } from "@modules/question-bank/views";

export const Route = createFileRoute("/_staff-area/question-bank")({
  staticData: { title: "nav.question-bank" },
  component: QuestionBankScreen,
});
